import {
    localCalendarDateInputToUtcIsoEndOfDay,
    localCalendarDateInputToUtcIsoStartOfDay,
} from '../../shared/utils/local-calendar-date-to-utc-iso.util';
import { DWT_PAYLOADS_ACTIVITY, resolveDwtPayloadsRecordCount } from '../dwt-payloads.constants';
import type {
    DwtPayloadsPayload,
    DwtPayloadsTaskPaneFilter,
    DwtPayloadsWireFilter,
} from '../models/dwt-payloads.model';

function buildWireFilter(filter: DwtPayloadsTaskPaneFilter): DwtPayloadsWireFilter {
    const recordCount = resolveDwtPayloadsRecordCount(filter.recordCount);
    const startDate = filter.startDate?.trim() ?? '';
    const endDate = filter.endDate?.trim() ?? '';
    const createdOnFrom = startDate ? localCalendarDateInputToUtcIsoStartOfDay(startDate) : null;
    const createdOnTo = endDate ? localCalendarDateInputToUtcIsoEndOfDay(endDate) : null;

    const wire: DwtPayloadsWireFilter = {
        startIndex: 0,
        recordCount,
        facilityCode: [...filter.facilityCode],
        status: [...filter.status],
    };
    if (createdOnFrom) {
        wire.createdOnFrom = createdOnFrom;
    }
    if (createdOnTo) {
        wire.createdOnTo = createdOnTo;
    }
    return wire;
}

/** Builds the Activity Handler envelope from a filter object (pure — no DOM). */
export function buildDwtPayloadsPayloadFromFilter(filter: DwtPayloadsTaskPaneFilter): DwtPayloadsPayload {
    return {
        activity: DWT_PAYLOADS_ACTIVITY,
        isAsync: false,
        data: { filters: buildWireFilter(filter) },
    };
}
